import { useState, useEffect } from "react";
import Axios from "axios";

const UseAddress = (url,update) => {
  const [data, setData] = useState([]);
  const userToken = localStorage.getItem('userToken');
  useEffect(() => {
    Axios.get(url,{
       headers: { 'Authorization': 'Bearer '+userToken }
    }).then((response)=>{
      if(response.data){
        setData(response.data);
      }
    }).catch((error) => {
      console.log(error)
    });
  }, [url,userToken,update]);

  return [data];
};

export default UseAddress;